<template>
    <SOSlotModal :modal-id="modalId" :modal-title="getTitle" @close="back">
        <template v-slot:modal-body>
            <div class="message-wrapper">
                <div class="msg msg-body f-14" v-html="getMessage"></div>
            </div>
        </template>
    </SOSlotModal>
</template>

<script>
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";

export default {
    name: "ModalPreviewMessage",
    components: {
        SOSlotModal,
    },
    data() {
        return {
            modalId: "modal-preview-message",
            modalTitle: "Pesan Blast",
        };
    },
    computed: {
        getMessage() {
            let msg = this.$route.params?.msg || "";
            if (msg) {
                msg.replace(/\n/g, "<br />")
                    .replace(/\*([^\*\~]+)\*/g, "<b>$1</b>")
                    .replace(/\_([^\_\~]+)\_/g, "<i>$1</i>");
            }
            return msg;
        },
        getTitle() {
            return this.modalTitle;
        },
    },
    mounted() {
        $(`#${this.modalId}`).modal("show");
    },
    beforeRouteLeave(to, from, next) {
        this.closeModal();
        next();
    },
    methods: {
        async back(idx = -1) {
            await this.$router.go(idx);
        },

        closeModal() {
            $(`#${this.modalId}`).modal("hide");
        },
    },
};
</script>

<style scoped>
.message-wrapper {
    background: #ede7de;
    margin: 0px -20px;
    margin-top: -4px;
    padding: 20px;
    max-height: 70vh;
    overflow-y: scroll;
    overflow-x: hidden;
}
.msg {
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    padding: 8px 12px;
}
.msg-head {
    background: inherit;
    margin-bottom: 20px;
}
.msg-body {
    background: #e0ffc6;
}
</style>
